// ProgressBar.jsx
import React from 'react';

const ProgressBar = ({ progress }) => {
  const progressBarStyle = {
    width: `${progress}%`,
    height: '12px',
    backgroundColor: '#125D38',
    textAlign: 'center',
    fontSize:'0',
    color: 'white',
    lineHeight: '20px',
    borderRadius: '0',
    transition: 'width 0.3s ease'
  };

  return (
    <div style={{ width: '100%', backgroundColor: '#e0e0e0', borderRadius: '20px' }}>
      <div style={progressBarStyle}></div>
    </div>
  );
};

export default ProgressBar;
